import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client (CLAUDE.md §11.3).
 *
 * - `staleTime: 30s` — cockpit/aggregate data is refreshed by the `/live` WebSocket, so
 *   the REST snapshot only needs occasional re-fetching; 30s avoids refetch storms.
 * - `retry: 1` — one retry tolerates a transient blip without masking a real outage.
 * - `refetchOnWindowFocus: false` — operations dashboards stay open for hours; focus
 *   refetches would be noise.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
